import type { Matcher, MatchStrategy } from './types';


// later on, we will support matching by "starts with", and other strategies.
const matchers: Record<MatchStrategy, Matcher> = {
  includes: (nodeLabel, searchQuery) => {
    const normalizedNodeLabel = nodeLabel.toLocaleLowerCase();
    const normalizedQuery = searchQuery.toLocaleLowerCase();

    return normalizedNodeLabel.includes(normalizedQuery);
  },
};


export function matchNode(args: {
  matchStrategy?: MatchStrategy;
  nodeLabel: string;
  searchQuery: string;
}) {
  const { matchStrategy = 'includes', nodeLabel, searchQuery } = args;

  return matchers[matchStrategy](nodeLabel, searchQuery);
}
